export default {
    creditCard: 'Credit Card',
    gPay: 'Gpay',
    applePay: 'Apple Pay',
};
